<script>
import { formatDateTimeBR } from "@src/helpers/date";
import ClaimStatusBadge from "@/src/components/ui-design/badges/ClaimStatusBadge.vue";

export default {
  components: {
    ClaimStatusBadge
  },
  props: {
    claim: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatDateTimeBR
  }
};
</script>

<template>
  <div class="sales-claim card-box p-3 px-0">
    <h6 class="sales-details__subtitle">Reclamação Vinculada</h6>
    <div class="mb-3">
      <div>Status</div>
      <ClaimStatusBadge :status="claim.status" />
    </div>
    <div>
      <div>Aberta em</div>
      <p class="sales-claim__text">{{ formatDateTimeBR(claim.created_at) }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sales-claim {
  &__text {
    color: #000c0b;
  }
}
</style>
